import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class EmployeeService {
  list = async ({ departmentId, allStatus, empId }) => {
    try {
      const params = qs.stringify({
        ...(departmentId && { departmentId }),
        ...(allStatus && { allStatus }),
        ...(empId && { empId }),
      });

      const response = await HttpClient.get(`/api/employee/list?${params}`);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  logs = async ({ empId }) => {
    try {
      const params = qs.stringify({
        ...(empId && { empId }),
      });

      const response = await HttpClient.get(`/api/employee/logs?${params}`);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  updateStatus = async (body) => {
    try {
      const response = await HttpClient.post(
        `/api/employee/updatestatus`,
        body
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  updateEmp = async (body) => {
    try {
      const response = await HttpClient.post(`/api/employee/add`, body);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
  AddEmp = async (data) => {
    try {
      const response = await HttpClient.post("/api/employee/add", data);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
}

export default new EmployeeService();
